import { Button, Input, InputNumber, Modal, Radio } from "antd";
import { useEffect, useState } from "react";
import useWsSender from "lib/wsSenderHook";
import { showToast } from "ui/components/common";

export default function ({ deviceId, nvr }) {
  const [enable, setEnable] = useState(false);
  const [scrapeInterval, setScrapeInterval] = useState(60);
  const [modalShow, setModalShow] = useState(false);
  const { sendWsRequest } = useWsSender();
  useEffect(() => {
    if (!nvr) return;
    setEnable(nvr?.apmParam?.enable || false);
    setScrapeInterval(nvr?.apmParam?.scrapeInterval || 60);
  }, [nvr]);
  const saveSetting = async () => {
    try {
      const res: any = await sendWsRequest(
        "device.refresh_nvr_cloud_settings",
        {
          deviceRefreshNvrCloudSettings: {
            apmParam: {
              enable,
              scrapeInterval,
            },
            id: deviceId,
          },
        },
      );
      setModalShow(false);
    } catch (e) {
      console.error(e);
      showToast(1, e.message);
    }
    return;
  };
  return (
    <>
      <Button onClick={() => setModalShow(true)} type="link">
        Device Cloud Setting Refresh
      </Button>
      <Modal
        title={"Cloud Setting Refresh"}
        open={modalShow}
        okButtonProps={{ className: "primaryButton" }}
        cancelButtonProps={{ className: "primaryButton bordered" }}
        onCancel={() => setModalShow(false)}
        onOk={saveSetting}
      >
        <Radio.Group
          value={enable}
          onChange={(e) => setEnable(e.target.value)}
          options={[
            { label: "Enable", value: true },
            { label: "Disable", value: false },
          ]}
        />
        <div style={{ marginTop: "12px" }}>
          <span>Scrape Interval:</span>
          <InputNumber
            min={10}
            max={3600}
            value={scrapeInterval}
            onChange={(e) => setScrapeInterval(e)}
            style={{ width: "200px" }}
          />
        </div>
      </Modal>
    </>
  );
}
